export default __webpack_public_path__ + "mlp-sworl-right-lg.b021e3c.png";